export function EmailVerificationBanner() {
  return (
    <div className="min-h-screen pt-24 px-4">
      <div className="max-w-2xl mx-auto bg-amber-50 rounded-lg p-6 text-center">
        <h2 className="text-xl font-semibold text-amber-800 mb-2">
          Email Verification Required
        </h2>
        <p className="text-amber-700">
          Please verify your email address to access the dashboard.
        </p>
      </div>
    </div>
  );
}
